export default "__VITE_ASSET__BE9Sh153__"